// noinspection JSUnusedLocalSymbols
import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import DataProvider from '../../../app/data-framework/data-provider';
import DataRepository from '../../../app/data-framework/data-repository';
import WebResourceSecure from './web-resource-secure.service';
import DataService from "./data.service";
import MetadataService from "../../../services/metadata.service";

    export default {

        addCiscoSparkBotToSpace: function (params) {
            return DataProvider.getInstance().fetchAssuranceCiscoSparkServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/bot';
                    return WebResourceSecure.getJSON(url, params, 'POST');
                });
        },

        removeCiscoSparkBotFromSpace: function (params) {
            return DataProvider.getInstance().fetchAssuranceCiscoSparkServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/bot/' + params.token + '/' + params.membershipId;
                    return WebResourceSecure.getJSON(url, params, 'DELETE');
                });
        },

        fetchCiscoSparkBotSpaceMembership: function (params) {
            return DataProvider.getInstance().fetchAssuranceCiscoSparkServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/bot/' + params.token + '/' + params.roomId;
                    return WebResourceSecure.getJSON(url);
                });
        },

        fetchCiscoSparkBotSpaceMemberships: function () {
            return DataProvider.getInstance().fetchAssuranceCiscoSparkServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/bot';
                    return WebResourceSecure.getJSON(url);
                });
        },

        fetchCiscoSparkSpaces: function (params) {
            return DataProvider.getInstance().fetchAssuranceCiscoSparkServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/spaces/' + params.token;
                    return WebResourceSecure.getJSON(url);
                });
        },

        fetchOrgPreferences: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + "/orgPreferences/" + params.key;
                    return WebResourceSecure.getJSON(url).then(function (response) {
                        return JSON.parse(response.d);
                    });
                });
        },

        syncEndpoint: function () {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + "/endpoints/sync";
                    return WebResourceSecure.getJSON(url, undefined,'POST');
                });
        },


        saveOrgPreferences: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + "/orgPreferences/" + params.key;
                    return WebResourceSecure.getJSON(url, params.value, 'POST').then(function (response) {
                        return response.d;
                    });
                });
        },


        /**
         * Retrieve the metadata for the dashboard.
         *
         */
        fetchFlexQueryMetadata: function () {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/metadata';
                    return WebResourceSecure.getJSON(url).then(function (response) {
                      return DataService.fetchAddCpmaDatasetMetadata().then(function (metadata) {
                        response.FilterCols.forEach(function (item) {
                          MetadataService.updateCpmaColMetadata(metadata, item.columnKey, item); // todo this should be better
                        });
                        response.Table.forEach(function (item) {
                          MetadataService.updateCpmaColMetadata(metadata, item.columnKey, item); // todo this should be better
                        });
                        DataRepository.getInstance().processWebServiceResult('GetFlexQueryMetaData', {}, response);
                        return response;
                      });

                    });
                });
        },

        /**
         * Retrieve fact data for the dashboards.
         *
         * @param params
         */
        fetchQueryResultDatasetJson: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/factdata';
                    return WebResourceSecure.getJSON(url, params, 'POST');
                });
        },

        /**
         * Retrieve the KPI data
         *
         * @param params
         */
        fetchKPI: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/kpi';
                    return WebResourceSecure.getJSON(url, params, 'POST');
                });
        },

        /**
         * Retrieve data for the specified query.
         *
         * @param params the query parameters
         */
        fetchQueryResultJson: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceV2BaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/query';
                    return WebResourceSecure.getJSON(url, params, 'POST').then(function (response) {
                        return response.results;
                    });
                });
        },

        /**
         * Retrieve the systems of type `systemType`.
         *
         * @param params - the system type (meeting / participant / etc)
         * @returns {*}
         */
        fetchSystems: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/systems';
                    if (params.page) {
                        url += '/' + params.page;
                    }
                    return WebResourceSecure.getJSON(url);
                });
        },

        /**
         * Retrieve the endpoint models.
         *
         * @returns {*}
         */
        fetchEndpoints: function () {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/endpoints';
                    return WebResourceSecure.getJSON(url);
                });
        },

        fetchEndpointsTemp: function () {
            return DataProvider.getInstance().fetchAssuranceAppsServiceBaseURL()
            .then(function (baseUrl) {
                var url = baseUrl + '/endpoints?thin=true&deleted=false';
                return WebResourceSecure.getJSON(url).then(function (response) {
                    // maintain backward-compatibility with the graphql response
                    response.forEach(function (item) {
                        item.id = '' + item.id;
                    });
                    return {
                        data: {
                            endpoints: response
                        }
                    };
                });
            });
        },

        fetchSystemsTemp: function () {
            return DataProvider.getInstance().fetchAssuranceAppsServiceBaseURL()
            .then(function (baseUrl) {
                var url = baseUrl + '/systems?thin=true';
                return WebResourceSecure.getJSON(url).then(function (response) {
                    // temporary fix to maintain backward-compatibility.  Can be
                    // removed once the "thin" API has been deployed.
                    response.forEach(function (item) {
                        if (typeof item.type === 'object' && item.type !== null) {
                            item.type = _.toUpper(item.type.name);
                        }
                    });
                    // maintain backward-compatibility with the graphql response
                    return {
                        data: {
                            systems: response
                        }
                    };
                });
            });
        },

        fetchUsersForCurrentOrgTemp: function () {
            return DataProvider.getInstance().fetchAssuranceAppsServiceBaseBaseURL()
            .then(function (baseUrl) {
                var url = baseUrl + '/users';
                return WebResourceSecure.getJSON(url);
            });
        },

        fetchUsersForOrgTemp: function (orgId) {
            return DataProvider.getInstance().fetchAssuranceAppsServiceBaseURLForOrg(orgId)
            .then(function (baseUrl) {
                var url = baseUrl + '/users';
                return WebResourceSecure.getJSON(url);
            });
        },


        fetchAllOrgsTemp: function () {
            return DataProvider.getInstance().fetchAssuranceAppsServiceBaseBaseURL()
            .then(function (baseUrl) {
                var url = baseUrl + '/orgs';
                return WebResourceSecure.getJSON(url);
            });
        },


        fetchEndpointHistoricalInfo: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/endpoints/' + params.appsEpId + '/historical';
                    return WebResourceSecure.getJSON(url);
                });
        },

          /**
           * Update the altName, description, tags, location, and price of the endpoint model.
           *
           * @returns {*}
           */
          updateEndpoint: function (params) {
              return DataProvider.getInstance().fetchAssuranceAppsServiceBaseURL()
                  .then(function (baseUrl) {
                      var url = baseUrl + '/endpoints/' + params.endpointId;
                      let endpointPatch = {
                          description: params.endpointData.description,
                          miscData: {
                              altName: params.endpointData.altName,
                              location: params.endpointData.location,
                              price: params.endpointData.price,
                              tags: params.endpointData.tags
                          }
                      };

                      return WebResourceSecure.getJSON(url, endpointPatch, 'PATCH');
                  });
          },

        /**
         * Retrieve the filters for a dataset
         *
         * @param params - the dataset (CallXml, etc)
         * @returns {*}
         */
        fetchFilters: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/filters';
                    if (params.datasetName) {
                        url += '/' + params.datasetName;
                    }
                    return WebResourceSecure.getJSON(url);
                })
              .then((filterMetadata) => {
                return DataService.fetchAddCpmaDatasetMetadata().then(function (metadata) {
                  filterMetadata.forEach(function (item) {
                    MetadataService.updateCpmaColMetadata(metadata, item.columnKey, item, params.datasetName); // todo this should be better
                  });
                  return filterMetadata;
                });
              });
        },

        fetchDatasetColumnsMetadata: function (datasetName) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/datasets/' + datasetName + '/detail';
                    return WebResourceSecure.getJSON(url).then(datasetMetadata => {
                      datasetMetadata.columns.forEach(c => c.datasetKey = datasetName.toLowerCase());
                      return datasetMetadata.columns; 
                    });
                });
        },

        fetchPermaLinkData: function (params) {
            return DataProvider.getInstance().fetchAssurancePreferencesServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/permalink/' + params.token;
                    return WebResourceSecure.getJSON(url);
                });
        },

        /**
         * Retrieve the preferences for `prefType` (historical2, for example)
         *
         * @returns {*}
         */
        // TODO: Should this be handled by PreferenceService? Is this used anywhere besides PreferenceManager?
        fetchPreferences: function (prefType) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/preferences/' + prefType;
                    return WebResourceSecure.getJSON(url);
                });
        },

        addExportRegistration: function(params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/exportRegistrations';
                    return WebResourceSecure.getJSON(url, params.value, 'POST');
                });
        },

        updateExportRegistration: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/exportRegistrations';
                    return WebResourceSecure.getJSON(url, params.value, 'PUT');
                });
        },


        deleteExportRegistration: function (params) {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/exportRegistrations/' + params.appId + '/' + params.id;
                    return WebResourceSecure.getJSON(url, undefined, 'DELETE');
                });
        },


        fetchExportRegistrations: function () {
            return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/exportRegistrations';
                    return WebResourceSecure.getJSON(url, undefined, 'GET');
                });
        },

        /**
         * Retrieves the rooms
         *
         * @param {Object} params - {}
         */
        fetchRooms: function() {
            return DataProvider.getInstance().fetchAssuranceAppsServiceV2BaseBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/orgs/rooms';
                    return WebResourceSecure.getJSON(url);
                });
        },

        /**
         * Updates the rooms
         *
         * @param {Object} params - {}
         */
        updateRooms: function(params) {
            var roomId = params[0].id;
            var endpoints = params[0].endpoints;
            return DataProvider.getInstance().fetchAssuranceAppsServiceV2BaseBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/orgs/rooms/' + roomId + '/endpoints';
                    return WebResourceSecure.getJSON(url, endpoints, 'PUT');
                });
        },

        /**
         * Send the user activity
         *
         * @param params
         */
        logUserActivity: function (params) {
            return DataProvider.getInstance().fetchLoggingServiceBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/activity';
                    return WebResourceSecure.getJSON(url, params, 'POST','text');
                })
            .catch(function (error) {
                console.error('unable to log activity', error);
                return Promise.reject(error);
            });
        },

        logAdminActivity: function (orgId, params) {
            return DataProvider.getInstance().fetchAdminServiceBaseBaseURL()
                .then(function (baseUrl) {
                    var url = baseUrl + '/orgs/' + orgId + '/log_activity';
                    return WebResourceSecure.getJSON(url, params, 'POST','text');
                })
            .catch(function (error) {
                console.error('unable to log admin activity', error);
                return Promise.reject(error);
            });
        }

    };
